import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggleable"]

  connect() {
    console.log('Conditional fields controller connected')
    // 初期表示時にも状態を反映
    this.toggle()
  }

  toggle(event) {
    const select = event?.target || this.element.querySelector('select')
    const selectedValue = select.value
    console.log('Selected value:', selectedValue)

    // 「yes」または「あり」の場合に表示
    if (selectedValue === "yes") {
      console.log('Show field')
      this.toggleableTarget.classList.remove("hidden")
    } else {
      console.log('Hide field')
      this.toggleableTarget.classList.add("hidden")
    }
  }
}